const BrandColors = {
  SEMANTIC_COLOR_PRIMARY: "blue",
  HEX_COLOR_PRIMARY: "#2196F3",
  HEX_COLOR_SUCCESS: "#00ca72"
};

export default BrandColors;